export const investSystems = [
  {
    name: 'Semantic Knowledge Platform',
    role: 'The knowledge foundation',
    link: '/semantic-knowledge',
    linkLabel: 'Explore SKP',
    status: '',
    paragraphs: [
      'The Semantic Knowledge Platform (SKP) is designed to organize concepts, relationships, sources, and approved knowledge. It combines structured content, vocabulary management, AI assisted extraction, expert review, knowledge graphs, semantic search, and GraphRAG.',
      'SKP can support scientific research, enterprise knowledge, and institutional learning. Customer implementations would adapt the foundation to each organization’s terminology, sources, permissions, and review processes.',
    ],
    note: '',
  },
  {
    name: 'Noetivra',
    role: 'The interactive workspace',
    link: '/noetivra',
    linkLabel: 'Explore Noetivra',
    status: 'Noetivra is currently in development.',
    paragraphs: [
      'Noetivra is a visual, interactive workspace for SyNeural’s connected knowledge and human capability systems. Installed on compatible devices, it helps people explore relationships, conduct assessments, review findings, and put knowledge into action.',
      'Its planned modules include Talent, Clinical, Research, Collaboration, and Human Capability. Customers could adopt the modules relevant to their work and add capabilities as their needs grow.',
      'Noetivra’s proposed commercial value lies in useful workflows, connected services, specialized modules, integrations, and support, offered through recurring licenses and organizational deployment services.',
    ],
    note: '',
  },
  {
    name: 'Human Capability Platform',
    role: 'The assessment and development framework',
    link: '/human-capability',
    linkLabel: 'Explore the frameworks',
    status: '',
    paragraphs: [
      'The Human Capability Platform brings together the Civic Judgment Index (CJI), Neurocognitive Civic Judgment Index (NCJI), assessment methods, development pathways, and supporting services.',
      'It provides the framework for studying and developing reasoning, judgment, self-direction, cooperation, and readiness for responsibility. Noetivra’s Human Capability Edition would bring these methods into assessment and development workflows.',
    ],
    note: 'Assessment methods require validation for their intended uses. Clinical and employment applications would have their own requirements; validation in one area would not establish suitability in another.',
  },
]

export const revenueStreams = [
  {
    stream: 'Implementation',
    purchase: 'Knowledge architecture, source preparation, vocabulary configuration, workflows, integrations, and deployment.',
  },
  { stream: 'SKP licensing', purchase: 'Continued access to the knowledge platform and its contracted capabilities.' },
  { stream: 'Noetivra licensing', purchase: 'Access to the core workspace and contracted services for individuals, teams, or institutions.' },
  {
    stream: 'Module subscriptions',
    purchase: 'Selected capabilities such as Talent, Research, Collaboration, or Human Capability.',
  },
  { stream: 'Support and maintenance', purchase: 'Technical support, upgrades, monitoring, and contracted service levels.' },
  {
    stream: 'Knowledge stewardship',
    purchase: 'Ongoing vocabulary updates, source integration, and approved knowledge maintenance.',
  },
  {
    stream: 'Expansion and integration',
    purchase: 'Additional departments, workflows, systems, and customer-specific capabilities.',
  },
  {
    stream: 'Training and services',
    purchase: 'Onboarding, reviewer training, assessment implementation, and development program support.',
  },
]

export const revenueScenarios = [
  { customers: '10', revenue: '$1 million' },
  { customers: '100', revenue: '$10 million' },
  { customers: '1,000', revenue: '$100 million' },
]

export const growthSteps = [
  {
    title: 'Prove a focused use case',
    body: 'Begin with a defined customer problem, such as connecting scientific findings or organizing research review. Establish measurable outcomes and demonstrate that the system helps users complete useful work.',
  },
  {
    title: 'Build repeatable deployments',
    body: 'Turn successful implementation patterns into reusable configurations, connectors, and workflows. The aim is to reduce the time and cost required to serve each additional customer.',
  },
  {
    title: 'Introduce Noetivra modules',
    body: 'Bring the knowledge foundation into practical workflows through modules that customers can adopt independently. Prioritize demand, measurable usefulness, and the validation required for each application.',
  },
  {
    title: 'Expand within customer organizations',
    body: 'Extend successful deployments to more teams, knowledge collections, and modules. Grow recurring contracts as customers adopt additional capabilities.',
  },
  {
    title: 'Scale delivery and partnerships',
    body: 'Develop the sales, implementation, and support capacity needed for larger institutions. Explore integration and delivery partnerships where they can improve reach and customer service.',
  },
]

export const investmentUses = [
  'SKP engineering and integration capabilities.',
  'Noetivra’s interface, integrations, and initial modules.',
  'Customer pilots and assessment validation.',
  'Security, permissions, and deployment options.',
  'Reusable implementation tools and configurations.',
  'Customer acquisition, onboarding, and support.',
]

export const progressMeasures = [
  'Deployment time',
  'Active use',
  'Customer outcomes',
  'Annual recurring revenue',
  'Renewals',
  'Expansion',
  'Delivery margins',
]
